/*********************************************************
 *                  Carrier Deposit Area Ctrl
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("DepositAreaCtrl", [
		"$scope", "Utils", "$uibModal", "DepositAreaService", "toastr", "DTOptionsBuilder", "DTColumnBuilder", "$location", "$compile", "$sanitize",
		function ($scope, Utils, $uibModal, DepositAreaService, toastr, DTOptionsBuilder, DTColumnBuilder, $location, $compile, $sanitize) {

		/**
		 * INIT
		 */
		var deleteModal, importModal;

		$scope.data = {
			depositArea: [],
			selectedDepositArea: {},
			typeList: ["PRIVE", "PUBLIQUE"],
			editMode: false,
			importFile: {}
		};

		var columnList = [
			{
				value: "name",
				name: "Nom",
				columnFilterParams: {
					type: "text"
				}
			}, {
				value: "adress",
				name: "Adresse",
				columnFilterParams: {
					type: "text"
				}
			}, {
				value: "zip",
				name: "Code postal",
				columnFilterParams: {
					type: "num"
				}
			}, {
				value: "city",
				name: "Ville",
				columnFilterParams: {
					type: "text"
				}
			}, {
				value: "latitude",
				name: "Latitude",
				columnFilterParams: {
					type: "num"
				}
			}, {
				value: "longitude",
				name: "Longitude",
				columnFilterParams: {
					type: "num"
				}
			}, {
				value: "type",
				name: "Type",
				columnFilterParams: {
					type: "select",
					values: $scope.data.typeList,
					"bSearchable": true // type
				}
			}, {
				value: "actions",
				name: "",
				columnFilterParams: {
					type: "html"
				},
				renderWith: actionsHtml
			}];

		// Création du tableau
		$scope.dtOptions = DTOptionsBuilder
			.newOptions()
			 .withOption("serverSide", true)
			 .withOption("processing", true)
			 .withOption("fnServerData",function (sSource, aoData, fnCallback) {
				 DepositAreaService.getDepositAreaWithFilters(createObjectRequestFilter(aoData))
					 .then((response) => {
						 const data = response.data;
						 fnCallback(data);
						 $scope.data.serverResponse = data;
						 $scope.data.depositArea = data.data;
					 });
			 })
			.withOption("fnFooterCallback", footerCallback)
			.withDisplayLength(10)
			.withOption("autoWidth", true)
			.withPaginationType("full_numbers")
			.withOption("createdRow", createdRow)
			.withColumnFilter({
				aoColumns: columnList.map(function(c) { return c.columnFilterParams; })
			})
			.withBootstrap()
			.withBootstrapOptions({
				ColVis: {
					classes: {
						masterButton: "btn btn-default"
					}
				}
			});



		$scope.dtInstance = {};
		// faire un tableau des colonnes
		$scope.dtColumns = [];
		columnList.forEach(function (column) {
			var columnBuilder = DTColumnBuilder.newColumn(column.value).withTitle(column.name);
			if (column.renderWith != null) {
				columnBuilder.renderWith(column.renderWith);
			}
			$scope.dtColumns.push(columnBuilder);
		});

		/**
			 * Formatter les inputs en fonction de leur type de recherche
			 * @param footer
			 */
		function footerCallback(footer) {
			var indexInputNumberType = [];
			columnList.forEach(function (column, index) {
				if (column.columnFilterParams != null) {
					if (column.columnFilterParams.type === "num") {
						indexInputNumberType.push(index);
					}
				}
			});
			indexInputNumberType.forEach(function (index) {
				$(footer).find("th:eq(" + index + ") input").attr("type", "number");
			});
		}

		/**
			 * Compiler la ligne d'une zone dépôt pour rendre possible les intéractions
			 * @param row
			 * @param data
			 * @param dataIndex
			 */
		function createdRow(row, data, dataIndex) {
			// Recompiling so we can bind Angular directive to the DT
			$compile(angular.element(row).contents())($scope);
		}

		/**
			 * Rendre les actions possibles sur la zone de dépôt
			 * @param data
			 * @param type
			 * @param full
			 * @param meta
			 * @returns {string}
			 */
		function actionsHtml(data, type, full, meta) {
			var actions = "<div class=\"btn-group\">";
			var editAction = "<a title=\"Editer les informations d'une zone de dépôt\" " +
					"href=\"#/manager/deposit-area/" + $sanitize(full.id) + "/edit\" " +
					"class=\"btn btn-primary\">" +
					"<span class=\"fa fa-pencil-alt\"></span>" +
					"</a>";

			var deleteAction = "<button title=\"Supprimer une zone de dépôt\" " +
					"ng-click=\"openDeleteModal(" + $sanitize(full.id) + ")\" " +
					"class=\"btn btn-danger\">" +
					"<span class=\"fa fa-trash\"></span>" +
					"</button>";

			actions += editAction + deleteAction;

			actions += "</div>";
			return actions;
		}

		/**
			 * Création d'un objet à retourner à la plateforme pour prendre en compte les filtres
			 *
			 * @param aoData
			 * @returns {{draw, columns: Array, order: {}, start, length, search}}
			 */
		function createObjectRequestFilter(aoData) {
			var resultToSend = {
				draw: aoData[0].value,
				columns: [],
				order: {},
				start: aoData[3].value,
				length: aoData[4].value,
				search: aoData[5].value.value,
			};
			aoData[1].value.forEach(function (column) {
				if (column.data != undefined) {
					var columnInfo = {};
					columnInfo.name = column.data;
					columnInfo.search = column.search.value;
					// Add "type" information on a column
					var columnSource = columnList.find(function (c){return c.value === column.data;});
					if (columnSource.columnFilterParams != null) {
						columnInfo.type = columnSource.columnFilterParams.type;
					}
					resultToSend.columns.push(columnInfo);
				}
			});

			aoData[2].value.forEach(function (order) {
				resultToSend.order.name = resultToSend.columns[order.column].name;
				resultToSend.order.dir = order.dir;
			});
			// Copie des filtres pour une éventuelle demande d'export CSV
			$scope.copyFilters = resultToSend;
			return resultToSend;
		}

		/**
			 * Remettre les filtres et la liste des zones de dépôts à 0
			 */
		$scope.razFilters = function () {
			$("#table tfoot input").val("").change();
			$("#table tfoot select").val("").change();
			$("#table").DataTable().state.clear();
		};

		/**
			 * Récupérer les zones de dépôts, éventuellement filtrées.
			 */
		$scope.getDepositArea = function () {
			$("#table").DataTable().search("").draw();
		};

		/**
			 * Ouvrir la popup pour suppression d'une zone de dépôt.
			 *
			 * @param depositAreaId
			 */
		$scope.openDeleteModal = function (depositAreaId) {
			var depositArea = $scope.data.depositArea.find(function(v) {return v.id === depositAreaId;});
			$scope.data.selectedDepositArea = depositArea;

			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
			 * Ouvrir la popup d'import.
			 */
		$scope.openImportModal = function () {
			importModal = Utils.openModal($uibModal, "import.html", $scope);
		};

		/**
			 * Valide la suppression d'une zone de dépôt.
			 *
			 * @param depositAreaId
			 */
		$scope.deleteDepositArea = function (depositAreaId) {
			DepositAreaService.deleteDepositAreaById(depositAreaId)
				.then(() => {
					toastr.success("Zone de dépot supprimée.");
					deleteModal.close();
					$scope.getDepositArea();
					$scope.data.selectedDepositArea = {};
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "Erreur lors de la suppression de la zone de dépot."));
				});
		};
	}]
	);

